export default __webpack_public_path__ + "static/media/dtt-landing.7819cbef.jpg";